// 时间类过滤器

/** 返回的时间格式为00:00:00的时间格式，不包括天
 * @method time1
 * @param {Number} val 传入一个时间戳
 * @return {String} 返回该时间戳所表示的时间
 */
export const time1 = (val) => {
  if (val < 0) return '00:00:00'

  let time = Math.floor(val * 1 / 1000)
  let h = Math.floor(time / 3600)
  h = h < 10 ? ('0' + h) : h
  let m = Math.floor(time % 3600 / 60)
  m = m < 10 ? ('0' + m) : m
  let s = Math.floor(time % 60)
  s = s < 10 ? ('0' + s) : s

  return h + ':' + m + ':' + s
}

/** 返回的时间只有小时
 * @method timeH
 * @param {Number} val 传入一个时间戳
 * @return {String} 返回该时间戳所表示的小时数
 */
export const timeH = (val) => {
  if (val < 0) return '00'
  let time = Math.floor(val * 1 / 1000)
  let h = Math.floor(time / 3600)
  h = h < 10 ? ('0' + h) : h
  return h
}

/** 返回的时间只有分钟
 * @method timeM
 * @param {Number} val 传入一个时间戳
 * @return {String} 返回该时间戳所表示的分钟数
 */
export const timeM = (val) => {
  if (val < 0) return '00'
  let time = Math.floor(val * 1 / 1000)
  let m = Math.floor(time % 3600 / 60)
  m = m < 10 ? ('0' + m) : m
  return m
}

/** 返回的时间只有秒钟
 * @method timeS
 * @param {Number} val 传入一个时间戳
 * @return {String} 返回该时间戳所表示的秒钟数
 */
export const timeS = (val) => {
  if (val < 0) return '00'
  let time = Math.floor(val * 1 / 1000)
  let s = Math.floor(time % 60)
  s = s < 10 ? ('0' + s) : s
  return s
}

/** 返回的时间格式为00:00:00的时间格式，不包括天
 * @method timeD
 * @param {Number} val 传入一个时间戳
 * @return {String} 返回该时间戳所表示的时间
 */
export const timeD = (val) => {
  if (val < 0) return '00:00:00'

  let time = Math.floor(val * 1 / 1000)
  let d = Math.floor(time / 3600 / 24)
  let h = Math.floor(time / 3600 % 24)
  h = h < 10 ? ('0' + h) : h
  let m = Math.floor(time % 3600 / 60)
  m = m < 10 ? ('0' + m) : m

  return d + '天' + h + '时' + m + '分'
}



// WEBPACK FOOTER //
// ./src/filters/time.js